module.exports = __webpack_public_path__ + "img/106_4.4894426a.png";